module.exports = __webpack_public_path__ + "static/media/8.56af0ef8.jpg";